<template>
    <v-container fluid>
        <settings-form
            :setting="setting"
            :titlePrefix="$t('forms.title_prefix.add')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import SettingsForm from './Form'
import Setting from '@/models/Setting'

export default {
    components: {
        SettingsForm,
    },

    data: () => {
        return {
            setting: new Setting(),
        }
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
